import React, { Component } from "react";
import { connect } from "react-redux";
import isEqual from "lodash/isEqual";

import withStyles from "@material-ui/core/styles/withStyles";
import Divider from "@material-ui/core/Divider";
import MuiButton from "@material-ui/core/Button";

import ArrowDownward from "@material-ui/icons/ArrowDownward";
import ArrowUpward from "@material-ui/icons/ArrowUpward";

import { PageHeader, SweetAlert, FETCH_START, FETCH_END, SAVING_START, SAVING_END, showNotification, RestMethods } from "jazasoft";

import { dataProvider } from "../../../App";
import handleError from "../../../utils/handleError";
import { toFixed, getDistinctValues, toFixedSigned, isEmpty } from "../../../utils/helpers";
import { REGEX_DECIMAL, REGEX_COMMA_SEPARATED_DECIMAL } from "../../../utils/regex";
import Table, { TextInput, Toolbar } from "../../../components/Table";
import CardHeader from "../../../components/CardHeader";

import { SET_LAY } from "../layslip/layReducer";
import { SpreadingType } from "../../../utils/types";

const Deviation = {
  SHORTAGE_EXCESS: "shortage-excess-meterage",
  ROLL_SPLITTING: "roll-splitting",
  WIDTH_VARIATION: "width-variation",
  MANUAL_PLAN: "manual-plan",
  MISSING: "missing",
  REJECTED: "rejected"
};

const rowMapper =
  marker =>
  ({ rollInfo, ...row }) => ({
    ...row,
    rollInfo,
    rollNo: rollInfo.rollNo,
    length: `${toFixed(rollInfo.length, 1)}`,
    currAvailable: `${toFixed(row.currRollLength, 2)} ${rollInfo.rollNo.includes("(") ? "" : `(${toFixed(rollInfo.length, 1)})`}`,
    style: rollInfo.style,
    color: rollInfo.color,
    shade: rollInfo.shade,
    shrinkage:
      rollInfo.warpShrPercent !== null && rollInfo.weftShrPercent !== null
        ? `L${toFixedSigned(-rollInfo.warpShrPercent)}% W${toFixedSigned(-rollInfo.weftShrPercent)}%`
        : "",
    width: rollInfo.width,
    plannedBalance: toFixed(row.plannedBalance, 2),
    aPly: row.actualPly,
    aBalance: row.actualBalance,
    cDeviation: row.causeDeviation,
    layLength: marker.layLength
  });

const styles = theme => ({
  container: {
    margin: "1.5em",
    padding: 0
  },
  card: {
    margin: "1.5em 0",
    padding: 0,

    boxShadow: theme.shadows[1],
    backgroundColor: "white"
  },
  displayCenter: {
    display: "flex",
    justifyContent: "center",
    padding: "1.5em"
  }
});

class LayFeedback extends Component {
  state = {
    rows: {},
    actualIds: [],
    manualIds: [], //ids of manual Roll
    plannedIds: [],
    layCompleted: false,
    deviationTypes: null,
    searchText: "",
    alertActive: false,
    sweetAlert: {
      title: "",
      message: "",
      showCancel: false,
      alertType: "" // danger|warning
    },
    dialogActive: false,
    row: {},
    rollList: []
  };

  componentDidMount() {
    if (!this.props.lay) {
      this.back();
      return;
    }
    this.initRows(this.props);
    this.fetchRolls(this.props.orderFlow);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.lay, nextProps.lay)) {
      this.initRows(nextProps);
      this.fetchRolls(nextProps.orderFlow);
    }
  }

  initRows = (props = this.props) => {
    const { lay, layList } = props;
    if (!lay || !layList) return;
    const { marker } = lay;
    const lays = layList.filter(lay => marker.id === lay.marker.id);

    const rowList = lays.flatMap(lay => lay.rowList).filter(row => row.actualLayNo === lay.layNo);

    let rows = rowList.map(rowMapper(marker));

    const actualIds = rows
      .filter(row => row.actualLayNo === lay.layNo && row.completed === true)
      .sort((a, b) => (a.serialNo && b.serialNo ? a.serialNo - b.serialNo : 0))
      .map(r => r.id);

    rows = rows.reduce((acc, row) => ({ ...acc, [row.id]: row }), {});
    this.setState({ rows, actualIds });
  };

  fetchRolls = orderFlow => {
    if (!orderFlow || this.state.rollList.length > 0) return;
    const options = {
      url: `rolls`,
      method: "get",
      params: { search: `cutOrderFlow.id==${orderFlow.id};(hasChild=='NULL',hasChild=='FALSE')`, size: 100000 }
    };

    this.props.dispatch({ type: FETCH_START });
    dataProvider(RestMethods.CUSTOM, undefined, options)
      .then(response => {
        const rollList = response.data.content.map(roll => ({
          ...roll,
          currAvailable: `${toFixed(roll.available, 1)} (${toFixed(roll.length, 1)})`,
          actualPly: 0,
          aPly: 0,
          actualBalance: `${toFixed(roll.available)}`,
          aBalance: `${toFixed(roll.available)}`,
          cDeviation: Deviation.MANUAL_PLAN
        }));
        this.setState({ rollList });
        this.props.dispatch({ type: FETCH_END });
      })
      .catch(err => {
        handleError(err, this.props.dispatch);
        this.props.dispatch({ type: FETCH_END });
      });
  };

  fetchLaySlip = () => {
    const { orderFlow, layTab, match } = this.props;
    if (orderFlow) {
      const orderId = match.params.orderId;
      const options = {
        url: `orders/${orderId}/lays`,
        method: "get",
        params: { flowId: orderFlow.id }
      };
      this.props.dispatch({ type: FETCH_START });
      dataProvider(RestMethods.CUSTOM, undefined, options)
        .then(response => {
          if (response.status === 200) {
            const layMap = response.data;
            const layList = layMap[layTab];
            const lay = layList.find(l => l.layNo === this.props.lay.layNo);
            this.props.dispatch({ type: SET_LAY, payload: { orderFlow, layTab, lay, layList } });
            this.setState({ manualIds: [] });
          }
          this.props.dispatch({ type: FETCH_END });
        })
        .catch(err => {
          console.log(err);
          this.props.dispatch({ type: FETCH_END });
        });
    }
  };

  getHeader = type => {
    const styleCount = this.props.orderFlow?.styleList?.length || 1;
    const colorCount = this.props.orderFlow?.colorList?.length || 1;

    if (type === "layslip") {
      let columns = [
        { dataKey: "action", title: "Action" },
        { dataKey: "rollNo", title: "Roll No." },
        { dataKey: "style", title: "Style" },
        { dataKey: "color", title: "Color" },
        { dataKey: "currAvailable", title: "Available" },
        { dataKey: "width", title: "Width" },
        { dataKey: "shade", title: "Shade" },
        {
          dataKey: "aPly",
          title: "Actual Plies",
          element: <TextInput type="number" width={80} onChange={this.onChange} />
        },
        {
          dataKey: "aBalance",
          title: "Actual Balance",
          element: <TextInput width={80} onChange={this.onChange} />
        }
      ];
      if (styleCount <= 1) {
        columns = columns.filter(c => c.dataKey !== "style");
      }
      if (colorCount <= 1) {
        columns = columns.filter(c => c.dataKey !== "color");
      }
      return columns;
    } else if (type === "stage") {
      let columns = [
        { dataKey: "action", title: "Action" },
        { dataKey: "rollNo", title: "Roll No." },
        { dataKey: "style", title: "Style" },
        { dataKey: "color", title: "Color" },
        { dataKey: "currAvailable", title: "Available" },
        { dataKey: "width", title: "Width" },
        { dataKey: "shrinkage", title: "Shrinkage" },
        { dataKey: "shade", title: "Shade" }
      ];
      return columns;
    }
  };

  validate = (layCompleted = false) => {
    const { orderFlow } = this.props;
    if (!orderFlow || !orderFlow.orderConfig) return;
    /**
     * Validation
     */
    let layRowList = this.state.actualIds.map(id => this.state.rows[id]);
    let manualRows = this.state.rollList.filter(roll => this.state.manualIds.includes(roll.id));
    const rows = [...layRowList, ...manualRows];
    let splitRolls = [];
    let shadeWisePlyMap = {};

    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];
      let { plannedPly, aPly, aBalance, actualBalance, cDeviation, causeDeviation, rollNo, shade, rollInfo } = row;
      if (!rollInfo) {
        plannedPly = 0;
      }
      shadeWisePlyMap[shade] = (shadeWisePlyMap[shade] || 0) + parseInt(aPly);
      let error;

      if (!error && !(REGEX_DECIMAL.test(aBalance) || REGEX_COMMA_SEPARATED_DECIMAL.test(aBalance))) {
        error = "Incorrect value for actualBalance. It should be postive numberic value or comma separated numeric value.";
      }
      if (parseInt(aPly) < 0) {
        error = "Ply must be positive number. Row = " + (i + 1) + ", Roll Number = " + rollNo;
      }
      if (SpreadingType.FACE_ONE_WAY !== orderFlow.orderConfig.spreadingType && orderFlow.orderConfig.plyPairPerRoll && parseInt(aPly) % 2 === 1) {
        error = "Ply must be in pair. Row = " + (i + 1) + ", Roll Number = " + rollNo;
      }

      //Show Warning if there shortage or excess of more than 10 meters
      let warning;

      const currLength = parseInt(aPly) * row.layLength + `${aBalance}`.split(",").reduce((acc, chunk) => acc + parseFloat(chunk.trim()), 0);
      const orignalLength = parseInt(plannedPly) * row.layLength + actualBalance.split(",").reduce((acc, chunk) => acc + parseFloat(chunk.trim()), 0);
      if (currLength - orignalLength > 10) {
        warning =
          "Confirm that roll - " +
          rollNo +
          " has excess fabric of " +
          toFixed(currLength - orignalLength) +
          " meters from mill. This can be a manual error in entry.";
      } else if (currLength - orignalLength < -10) {
        warning =
          "Confirm that roll - " +
          rollNo +
          " has  fabric shortage of " +
          toFixed(currLength - orignalLength) +
          " meters from mill. This can be a manual error in entry.";
      }

      if (error) {
        this.setState({ alertActive: true, sweetAlert: { title: "Error", message: error, alertType: "danger" } });
        return;
      }

      if (warning) {
        this.setState({
          alertActive: true,
          sweetAlert: {
            title: "Are you sure?",
            alertType: "warning",
            message: warning
          },
          layCompleted
        });
        return;
      }

      if (cDeviation && cDeviation === Deviation.MANUAL_PLAN && `${aBalance}`.includes(",") && (!causeDeviation || causeDeviation !== cDeviation)) {
        splitRolls.push(rollNo);
      }
    }

    if (splitRolls.length > 0) {
      this.setState({
        alertActive: true,
        sweetAlert: {
          title: "Are you sure?",
          alertType: "warning",
          message: "Confirm that roll No [" + splitRolls.join(", ") + "] has/have been split. Feedback for split rolls cannot be modified later."
        },
        layCompleted
      });
      return;
    }

    if (layCompleted) {
      if (SpreadingType.FACE_ONE_WAY !== orderFlow.orderConfig.spreadingType) {
        let error;
        Object.keys(shadeWisePlyMap).forEach(shade => {
          if (shadeWisePlyMap[shade] % 2 === 1) {
            error = "Plies must be in pair for shade = " + shade;
          }
        });
        if (error) {
          this.setState({
            alertActive: true,
            sweetAlert: {
              title: "Error",
              message: error,
              alertType: "danger"
            }
          });
          return;
        }
      }
      this.setState({
        alertActive: true,
        sweetAlert: {
          alertType: "warning",
          title: "Are you sure?",
          message: "You are marking this lay completed. Please, Review lay carefully as you will not be able to modify once lay is marked completed."
        },
        layCompleted
      });
      return;
    }
    this.onSave(layCompleted);
  };

  onSave = layCompleted => {
    const { layTab, lay, orderFlow, match } = this.props;
    if (!orderFlow) return;
    this.setState({ alertActive: false, sweetAlert: {} });

    let layRowList = this.state.actualIds.map(id => this.state.rows[id]);
    let manualRows = this.state.rollList.filter(roll => this.state.manualIds.includes(roll.id)).map(roll => ({ ...roll, rollInfo: roll, id: null }));
    let rows = [...layRowList, ...manualRows];

    const orderId = match.params.orderId;
    rows = rows.map((row, idx) => ({
      ...row,
      actualPly: row.aPly,
      actualBalance: row.aBalance,
      causeDeviation: "manual-plan",
      serialNo: idx + 1
    }));
    let options = {
      url: `orders/${orderId}/feedback`,
      method: "post",
      params: { flowId: orderFlow.id, action: "layslip" },
      data: { layRowList: rows, layNo: lay.layNo, layTab, layCompleted: layCompleted || this.state.layCompleted }
    };

    this.props.dispatch({ type: FETCH_START });
    this.props.dispatch({ type: SAVING_START });
    dataProvider(RestMethods.CUSTOM, undefined, options)
      .then(response => {
        if (response.status === 200) {
          this.props.dispatch(showNotification("Feedback saved successfully."));
          if (layCompleted || this.state.layCompleted) {
            this.back();
          } else {
            this.fetchLaySlip();
          }
        }
        this.props.dispatch({ type: FETCH_END });
        this.props.dispatch({ type: SAVING_END });
      })
      .catch(err => {
        handleError(err, this.props.dispatch);
        this.props.dispatch({ type: FETCH_END });
        this.props.dispatch({ type: SAVING_END });
      });
  };

  back = () => {
    const {
      history,
      location: { pathname, state }
    } = this.props;
    history.push(pathname.substring(0, pathname.length - 4), state);
  };

  onSearch = searchText => {
    this.setState({ searchText });
  };

  onChange =
    ({ column, record }) =>
    event => {
      // const value = e.target.value;
      // this.setState(({ rows }) => {
      //   let newRows = [...rows];
      //   const row = { ...newRows[rowIdx], [column.dataKey]: value };
      //   newRows.splice(rowIdx, 1, row);
      //   return { rows: newRows };
      // });
      if (!record.id) return;
      let rows = { ...this.state.rows };
      let rollList = this.state.rollList.slice();
      const layLength = this.props.lay.marker.layLength;

      const value = event.target ? event.target.value : event.value;
      let row = rows[record.id];
      if (!row) {
        row = rollList.find(roll => roll.id === record.id);
      }
      row[column.dataKey] = value;
      if (column.dataKey === "aPly") {
        if (REGEX_DECIMAL.test(record.aBalance) && REGEX_DECIMAL.test(record.actualBalance)) {
          let aBalance = parseFloat(record.actualBalance);
          aBalance += layLength * (parseInt(record.actualPly) - parseInt(value.trim() === "" ? "0" : value.trim()));
          row["aBalance"] = toFixed(aBalance, 2);
        }
      }
      let dialogActive = false;
      let layRow = {};
      if (column.dataKey === "cDeviation") {
        if (value === Deviation.WIDTH_VARIATION) {
          dialogActive = true;
          layRow = record;
        } else {
          row["remarks"] = null;
        }
      }
      this.setState({ rows, rollList, row: layRow, dialogActive });
    };

  onMoveUp = (event, rowData) => {
    const manualIds = [...this.state.manualIds, rowData.id];
    this.setState({ manualIds });
  };

  onMoveDown = (event, rowData) => {
    const manualIds = this.state.manualIds.filter(id => id !== rowData.id);
    this.setState({ manualIds });
  };

  onCancel = () => {
    this.setState({ alertActive: false, sweetAlert: {} });
  };

  onClose = rows => {
    let rowList = { ...this.state.rows };
    if (this.state.row && this.state.row.id) {
      rowList[this.state.row.id]["remarks"] = JSON.stringify(
        rows.map(row => Object.keys(row).reduce((acc, key) => ({ ...acc, [key]: parseFloat(row[key]) }), {}))
      );
    }
    this.setState({ dialogActive: false, rows: rowList, row: {} });
  };

  render() {
    const { classes, lay, saving } = this.props;
    const { rows = {}, actualIds, manualIds, searchText, alertActive, sweetAlert, rollList } = this.state;
    const layLength = lay && lay.marker && lay.marker.layLength;

    const sizeGroup = !isEmpty(lay?.marker?.name) ? getDistinctValues(lay.marker.name?.split(", ").map(e => e.split("_")[0])) : null;
    const markerName = !isEmpty(lay?.marker?.name)
      ? lay.marker.name
          ?.split(", ")
          .map(e => e.split("_")[1])
          .join(", ")
      : "";

    const rowsActual = getDistinctValues(actualIds)
      .map(id => rows[id])
      .map(row => ({
        ...row,
        action: !row.completed ? <ArrowDownward onClick={e => this.onMoveDown(e, row)} /> : null
      }));
    const rowsActualManual = getDistinctValues(manualIds)
      .map(id => rollList.find(roll => roll.id === id))
      .map(roll => ({
        ...roll,
        action: <ArrowDownward onClick={e => this.onMoveDown(e, roll)} />
      }));

    let actualRollIds = [...rowsActual.map(row => row.rollInfo && row.rollInfo.id), ...manualIds];
    let rowsPlanned = rollList
      .filter(roll => roll.available >= layLength)
      .filter(roll => !actualRollIds.includes(roll.id))
      .map(roll => ({
        ...roll,
        shrinkage: `${
          roll.warpShrPercent !== null && roll.weftShrPercent !== null
            ? `L${toFixedSigned(-roll.warpShrPercent)}% W${toFixedSigned(-roll.weftShrPercent)}%`
            : "-"
        }`,
        action: <ArrowUpward onClick={e => this.onMoveUp(e, roll)} />
      }));

    rowsPlanned =
      searchText.trim() === "" ? rowsPlanned : rowsPlanned.filter(roll => roll.rollNo.toLowerCase().includes(searchText.trim().toLocaleLowerCase()));

    return (
      <div className={classes.root}>
        {/* <PageHeader title={`Lay #${lay && lay.layNo}`} /> */}

        <PageHeader
          title={`Lay ${lay && lay.layNo}, Marker - ${markerName}${
            !isEmpty(sizeGroup) && sizeGroup !== "G1" ? ` (${sizeGroup})` : ""
          }, Lay Length = ${layLength}m`}
        />

        {alertActive && (
          <SweetAlert
            warning={sweetAlert.alertType === "warning"}
            danger={sweetAlert.alertType === "danger"}
            title={sweetAlert.title}
            onConfirm={sweetAlert.alertType === "warning" ? this.onSave : this.onCancel}
            onCancel={this.onCancel}
            showCancel={sweetAlert.alertType === "warning"}>
            <span style={{ fontSize: 16 }}>{sweetAlert.message}</span>
          </SweetAlert>
        )}

        <div className={classes.container}>
          <div className={classes.card}>
            <CardHeader title="Actual Layslip" style={{ marginLeft: 0 }} />
            <Divider />
            <div style={{ overflowX: "auto" }}>
              <Table
                columns={this.getHeader("layslip")}
                rows={rowsActual.length > 0 || rowsActualManual.length > 0 ? [...rowsActual, ...rowsActualManual] : [{}]}
              />

              <div style={{ display: "flex", justifyContent: "space-between", padding: "1em" }}>
                <div>
                  <MuiButton color="primary" variant="outlined" onClick={this.back}>
                    Back
                  </MuiButton>
                </div>
                <div>
                  <MuiButton color="primary" variant="outlined" disabled={saving} onClick={() => this.validate(true)}>
                    Submit
                  </MuiButton>
                  <MuiButton color="primary" variant="contained" style={{ marginLeft: "1em" }} disabled={saving} onClick={() => this.validate(false)}>
                    Save
                  </MuiButton>
                </div>
              </div>
            </div>
          </div>
          <div className={classes.card}>
            <Table
              columns={this.getHeader("stage")}
              rows={[...rowsPlanned]}
              toolbar={
                <Toolbar
                  title="Planned Layslip"
                  actions={[
                    {
                      name: "search",
                      tooltip: "Search Rolls",
                      placeholder: "Search",
                      value: searchText,
                      onSearch: this.onSearch
                    }
                  ]}
                />
              }
            />
          </div>
        </div>
      </div>
    );
  }
}

export default connect((state, props) => ({
  ...state.lay,
  orderId: props.match && props.match.params.orderId,
  saving: state.jazasoft.saving
}))(withStyles(styles)(LayFeedback));
